@if (isLoading) {
<div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm flex items-center justify-center py-24">
  <app-progress-loader></app-progress-loader>
</div>
} @else if (loan) {
<div class="space-y-4">

  <!-- Page Header -->
  <div class="flex items-center justify-between">
    <div class="flex items-center gap-3">
      <button (click)="onClose()"
        class="w-8 h-8 rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 flex items-center justify-center transition-colors shadow-sm">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-slate-500 dark:text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <div>
        <h2 class="text-base font-bold text-slate-900 dark:text-white">Loan Application</h2>
        @if (loan.reference) {
        <p class="text-[11px] text-slate-400 font-mono">Ref: {{ loan.reference }}</p>
        }
      </div>
    </div>
    @if (loan.status === 'DISBURSED') {
    @if (permissionService.canRecordPayment()) {
    <button (click)="openRepayModal()"
      class="px-4 py-2 rounded-lg bg-primary-800 hover:bg-primary-900 text-white text-xs font-semibold flex items-center gap-1.5 transition-colors shadow-sm">
      <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      Record Repayment
    </button>
    }
    }
  </div>

  <!-- Applicant + Loan Info Row -->
  <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">

    <!-- Applicant Card -->
    <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
      <div class="h-1 bg-primary-800 w-full"></div>
      <div class="p-5">
        <p class="text-xs font-semibold text-slate-400 mb-3">Applicant</p>
        <div class="flex items-center gap-3 mb-4">
          <div class="w-11 h-11 rounded-full bg-primary-800 flex items-center justify-center text-white text-sm font-bold flex-shrink-0 shadow-sm">
            {{ (loan.user?.firstName?.[0] ?? '') + (loan.user?.lastName?.[0] ?? '') | uppercase }}
          </div>
          <div class="min-w-0">
            <p class="text-sm font-bold text-slate-900 dark:text-white truncate">{{ loan.user?.firstName }} {{ loan.user?.lastName }}</p>
            @if (loan.user?.otherName) {
            <p class="text-[11px] text-slate-400 truncate">{{ loan.user?.otherName }}</p>
            }
          </div>
        </div>
        <div class="border-t border-slate-100 dark:border-slate-700/50 pt-3 space-y-2.5">
          @if (loan.user?.mobileNumber) {
          <div class="flex items-center gap-2.5">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-slate-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            <p class="text-[11px] text-slate-700 dark:text-slate-300">{{ loan.user?.mobileNumber }}</p>
          </div>
          }
          @if (loan.user?.email) {
          <div class="flex items-center gap-2.5">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-slate-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            <p class="text-[11px] text-slate-700 dark:text-slate-300 truncate">{{ loan.user?.email }}</p>
          </div>
          }
          @if (loan.user?.ghanaCardNumber) {
          <div class="flex items-center gap-2.5">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-slate-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V8a2 2 0 00-2-2h-5m-4 0V5a2 2 0 114 0v1m-4 0a2 2 0 104 0" />
            </svg>
            <p class="text-[11px] font-mono text-slate-700 dark:text-slate-300">{{ loan.user?.ghanaCardNumber }}</p>
          </div>
          }
          @if (loan.userMonthlyIncome) {
          <div class="flex items-center gap-2.5">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-slate-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <p class="text-[11px] text-slate-700 dark:text-slate-300">₵{{ loan.userMonthlyIncome | number:'1.2-2' }} / mo</p>
          </div>
          }
          @if (loan.user?.kyc?.address) {
          <div class="flex items-start gap-2.5">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5 text-slate-400 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <p class="text-[11px] text-slate-700 dark:text-slate-300 leading-relaxed">{{ loan.user?.kyc?.address }}</p>
          </div>
          }
        </div>
      </div>
    </div>

    <!-- Loan Details -->
    <div class="lg:col-span-2 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
      <div class="h-1 bg-slate-200 dark:bg-slate-700 w-full"></div>
      <div class="p-5">
        <div class="flex items-center justify-between mb-4">
          <p class="text-xs font-semibold text-slate-400">Loan Details</p>
          @if (loan.status) {
          <span class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider"
            [ngClass]="{
              'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-900': loan.status === 'DISBURSED' || loan.status === 'ACTIVE',
              'bg-rose-50 dark:bg-rose-950/40 text-rose-600 dark:text-rose-400 border border-rose-100 dark:border-rose-900': loan.status === 'OVERDUE' || loan.status === 'DEFAULTED',
              'bg-purple-50 dark:bg-purple-950/40 text-purple-600 dark:text-purple-400 border border-purple-100 dark:border-purple-900': loan.status === 'COMPLETED',
              'bg-amber-50 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 border border-amber-100 dark:border-amber-900': loan.status === 'PENDING',
              'bg-slate-50 dark:bg-slate-800/60 text-slate-500 dark:text-slate-400 border border-slate-200 dark:border-slate-700': !['DISBURSED','ACTIVE','OVERDUE','DEFAULTED','COMPLETED','PENDING'].includes(loan.status)
            }">
            <span class="w-1.5 h-1.5 rounded-full inline-block"
              [ngClass]="{
                'bg-emerald-500': loan.status === 'DISBURSED' || loan.status === 'ACTIVE',
                'bg-rose-500': loan.status === 'OVERDUE' || loan.status === 'DEFAULTED',
                'bg-purple-500': loan.status === 'COMPLETED',
                'bg-amber-500': loan.status === 'PENDING',
                'bg-slate-400': !['DISBURSED','ACTIVE','OVERDUE','DEFAULTED','COMPLETED','PENDING'].includes(loan.status)
              }"></span>
            {{ loan.status }}
          </span>
          }
        </div>

        <!-- Key figures row -->
        <div class="grid grid-cols-3 gap-4 pb-4 border-b border-slate-100 dark:border-slate-700/50 mb-4">
          <div>
            <p class="text-xs font-semibold text-slate-400 mb-1">Principal</p>
            <p class="text-xl font-bold text-slate-900 dark:text-white">₵{{ (loan.amount ?? loan.principal_amount) | number:'1.2-2' }}</p>
          </div>
          <div>
            <p class="text-xs font-semibold text-slate-400 mb-1">Monthly</p>
            <p class="text-xl font-bold text-primary-800 dark:text-primary-400">₵{{ loan.monthlyRepayment | number:'1.2-2' }}</p>
          </div>
          <div>
            <p class="text-xs font-semibold text-slate-400 mb-1">Total Repayment</p>
            <p class="text-xl font-bold text-slate-900 dark:text-white">₵{{ (loan.totalRepayment ?? 0) | number:'1.2-2' }}</p>
          </div>
        </div>

        <!-- Secondary details grid -->
        <div class="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-3">
          <div>
            <p class="text-xs font-semibold text-slate-400 mb-0.5">Interest Rate</p>
            <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">{{ loan.interestRate }}%</p>
          </div>
          <div>
            <p class="text-xs font-semibold text-slate-400 mb-0.5">Tenure</p>
            <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">{{ loan.tenure }} {{ loan.product?.tenureType === 'DAILY' ? 'day' : 'month' }}{{ loan.tenure !== 1 ? 's' : '' }}</p>
          </div>
          @if (loan.processingFee) {
          <div>
            <p class="text-xs font-semibold text-slate-400 mb-0.5">Processing Fee</p>
            <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">₵{{ loan.processingFee | number:'1.2-2' }}</p>
          </div>
          }
          @if (loan.disbursedAt) {
          <div>
            <p class="text-xs font-semibold text-slate-400 mb-0.5">Disbursed</p>
            <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">{{ loan.disbursedAt | date:'d MMM yyyy' }}</p>
          </div>
          }
          @if (loan.repaymentDate) {
          <div>
            <p class="text-xs font-semibold text-slate-400 mb-0.5">Due Date</p>
            <p class="text-sm font-semibold text-slate-700 dark:text-slate-300">{{ loan.repaymentDate | date:'d MMM yyyy' }}</p>
          </div>
          }
          @if (loan.product?.name) {
          <div>
            <p class="text-xs font-semibold text-slate-400 mb-0.5">Product</p>
            <p class="text-sm font-semibold text-slate-700 dark:text-slate-300 truncate">{{ loan.product?.name }}</p>
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Repayment Summary + Progress -->
  <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
    <div class="grid grid-cols-3 divide-x divide-slate-100 dark:divide-slate-700">
      <!-- Total Repaid -->
      <div class="px-5 py-4 flex items-center gap-3">
        <div class="w-9 h-9 rounded-lg bg-emerald-50 dark:bg-emerald-950/40 flex items-center justify-center flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div>
          <p class="text-xs font-semibold text-slate-400 mb-0.5">Total Repaid</p>
          <p class="text-base font-bold text-emerald-600">₵{{ totalRepaid | number:'1.2-2' }}</p>
        </div>
      </div>
      <!-- Outstanding -->
      <div class="px-5 py-4 flex items-center gap-3">
        <div class="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
          [class]="balance <= 0 ? 'bg-emerald-50 dark:bg-emerald-950/40' : 'bg-rose-50 dark:bg-rose-950/40'">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5" [class]="balance <= 0 ? 'text-emerald-500' : 'text-rose-500'" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <div>
          <p class="text-xs font-semibold text-slate-400 mb-0.5">Outstanding</p>
          <p class="text-base font-bold" [class]="balance <= 0 ? 'text-emerald-600' : 'text-rose-600'">₵{{ balance | number:'1.2-2' }}</p>
        </div>
      </div>
      <!-- Payments Made -->
      <div class="px-5 py-4 flex items-center gap-3">
        <div class="w-9 h-9 rounded-lg bg-primary-800/10 flex items-center justify-center flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" class="w-4.5 h-4.5 text-primary-800 dark:text-primary-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
          </svg>
        </div>
        <div>
          <p class="text-xs font-semibold text-slate-400 mb-0.5">Payments Made</p>
          <p class="text-base font-bold text-slate-900 dark:text-white">{{ loanRepayments.length }}</p>
        </div>
      </div>
    </div>
    <!-- Progress Bar -->
    <div class="px-5 py-3 border-t border-slate-100 dark:border-slate-700/50 bg-slate-50 dark:bg-slate-800/60">
      <div class="flex items-center justify-between mb-1.5">
        <p class="text-[10px] font-bold text-slate-500 dark:text-slate-400 uppercase tracking-widest">Repayment Progress</p>
        <p class="text-[11px] font-bold" [class]="repaymentProgress >= 100 ? 'text-emerald-600' : 'text-slate-600 dark:text-slate-400'">
          {{ repaymentProgress | number:'1.0-0' }}%
        </p>
      </div>
      <div class="h-2 bg-slate-200 dark:bg-slate-700 rounded-full overflow-hidden">
        <div class="h-full rounded-full transition-all duration-500"
          [class]="repaymentProgress >= 100 ? 'bg-emerald-500' : repaymentProgress > 50 ? 'bg-primary-800' : 'bg-amber-400'"
          [style.width.%]="repaymentProgress">
        </div>
      </div>
    </div>
  </div>

  <!-- Repayment History -->
  <div class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden">
    <div class="px-5 py-4 border-b border-slate-200 dark:border-slate-700 flex items-center justify-between">
      <h3 class="text-sm font-bold text-slate-800 dark:text-slate-100">Repayment History</h3>
      @if (!isLoadingRepayments && loanRepayments.length > 0) {
      <span class="text-[10px] font-bold px-2 py-0.5 rounded-full bg-slate-100 dark:bg-slate-900 text-slate-500 dark:text-slate-400">
        {{ loanRepayments.length }} record{{ loanRepayments.length !== 1 ? 's' : '' }}
      </span>
      }
    </div>

    @if (isLoadingRepayments) {
    <div class="flex items-center justify-center py-10">
      <div class="w-5 h-5 border-2 border-slate-200 dark:border-slate-700 border-t-primary rounded-full animate-spin"></div>
    </div>
    } @else if (loanRepayments.length === 0) {
    <div class="flex flex-col items-center justify-center py-12 text-center px-4">
      <div class="w-10 h-10 bg-slate-50 dark:bg-slate-800/60 rounded-full flex items-center justify-center mb-3 border border-slate-100 dark:border-slate-700/50">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-slate-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
        </svg>
      </div>
      <p class="text-xs font-semibold text-slate-600 dark:text-slate-400">No repayments recorded yet</p>
    </div>
    } @else {
    <!-- Table header -->
    <div class="grid grid-cols-6 gap-4 px-5 py-2.5 bg-slate-50 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700">
      <div><p class="text-xs font-semibold text-slate-400">Date</p></div>
      <div class="col-span-2"><p class="text-xs font-semibold text-slate-400">Transaction ID</p></div>
      <div><p class="text-xs font-semibold text-slate-400">Type</p></div>
      <div><p class="text-xs font-semibold text-slate-400">Amount Paid</p></div>
      <div><p class="text-xs font-semibold text-slate-400">Comment</p></div>
    </div>
    @for (r of loanRepayments; track r.id) {
    <div class="grid grid-cols-6 gap-4 px-5 py-3.5 border-b border-slate-100 dark:border-slate-700/50 last:border-0 hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 transition-colors items-center">
      <div>
        <p class="text-[11px] font-bold text-slate-700 dark:text-slate-300">{{ r.date | date:'d MMM yyyy' }}</p>
        <p class="text-[10px] text-slate-400">{{ r.createdAt | date:'h:mm a' }}</p>
      </div>
      <div class="col-span-2">
        <p class="text-[11px] font-mono text-slate-600 dark:text-slate-400 truncate" [title]="r.transactionId">{{ r.transactionId }}</p>
      </div>
      <div>
        @if (r.type === 'BANK') {
        <span class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold bg-blue-50 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400 border border-blue-100 dark:border-blue-900 uppercase tracking-wider">Bank</span>
        } @else if (r.type === 'MOMO') {
        <span class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold bg-amber-50 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 border border-amber-100 dark:border-amber-900 uppercase tracking-wider">MoMo</span>
        } @else if (r.type === 'CASH') {
        <span class="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-bold bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-900 uppercase tracking-wider">Cash</span>
        } @else {
        <span class="text-[10px] text-slate-400">—</span>
        }
      </div>
      <div>
        <p class="text-[12px] font-bold text-emerald-600">₵{{ +r.amount | number:'1.2-2' }}</p>
      </div>
      <div>
        <p class="text-[11px] text-slate-500 dark:text-slate-400 truncate">{{ r.comment || '—' }}</p>
      </div>
    </div>
    }
    }
  </div>
</div>
} @else {
<div
  class="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 shadow-sm flex flex-col items-center justify-center py-24 text-center px-6">
  <div class="w-16 h-16 bg-slate-50 dark:bg-slate-800/60 rounded-full flex items-center justify-center mb-4 text-slate-300">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="12" y1="18" x2="12" y2="12" />
      <line x1="9" y1="15" x2="15" y2="15" />
    </svg>
  </div>
  <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100">Application Not Found</h3>
  <p class="text-sm text-slate-500 dark:text-slate-400 mt-2 max-w-sm">We couldn't retrieve the details for this loan application.</p>
  <button (click)="onClose()"
    class="mt-6 px-6 py-2 bg-primary-800 text-white text-xs font-bold uppercase tracking-widest rounded transition-all hover:bg-primary-800/90">
    Back to Products
  </button>
</div>
}

<!-- Record Repayment Modal -->
@if (showRepayModal) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm px-4">
  <div class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
    <div class="flex items-center justify-between px-6 py-4 border-b border-slate-100 dark:border-slate-700/50 bg-slate-50 dark:bg-slate-800/60">
      <div>
        <h3 class="text-sm font-bold text-slate-900 dark:text-white">Record Repayment</h3>
        <p class="text-[11px] text-slate-400 mt-0.5 font-mono">Ref: {{ loan?.reference || (loan?.id | slice:0:16) }}</p>
      </div>
      <button (click)="closeRepayModal()"
        class="w-8 h-8 rounded-full bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 flex items-center justify-center transition-colors shadow-sm">
        <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-slate-500 dark:text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <form [formGroup]="repayForm" (ngSubmit)="submitRepayment()" class="p-6 space-y-4">
      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Repayment Type <span class="text-error">*</span></label>
        <app-custom-select-input
          formControlName="type"
          [options]="repaymentTypes"
          [placeholder]="'Select repayment type'">
        </app-custom-select-input>
        @if (repayForm.get('type')?.invalid && repayForm.get('type')?.touched) {
        <p class="text-xs text-error mt-1">Repayment type is required</p>
        }
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Transaction ID <span class="text-error">*</span></label>
        <app-custom-input formControlName="transactionId" [placeholder]="'Enter transaction ID'" [isRequired]="true"></app-custom-input>
        @if (repayForm.get('transactionId')?.invalid && repayForm.get('transactionId')?.touched) {
        <p class="text-xs text-error mt-1">Transaction ID is required</p>
        }
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Amount (₵) <span class="text-error">*</span></label>
        <app-custom-input formControlName="amount" [type]="'number'" [placeholder]="'0.00'" [isRequired]="true"></app-custom-input>
        @if (repayForm.get('amount')?.invalid && repayForm.get('amount')?.touched) {
        <p class="text-xs text-error mt-1">A valid amount is required</p>
        }
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Date <span class="text-error">*</span></label>
        <app-custom-input formControlName="date" [type]="'date'" [isRequired]="true" [max]="today"></app-custom-input>
        @if (repayForm.get('date')?.invalid && repayForm.get('date')?.touched) {
        <p class="text-xs text-error mt-1">Date is required</p>
        }
      </div>

      <div>
        <label class="block text-xs font-semibold text-slate-600 dark:text-slate-400 mb-1.5">Comment</label>
        <app-custom-input formControlName="comment" [placeholder]="'Optional note'" [isTextarea]="true" [rows]="3"></app-custom-input>
      </div>

      <div class="flex gap-3 pt-1">
        <button type="button" (click)="closeRepayModal()"
          class="flex-1 h-11 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 text-sm font-semibold hover:bg-slate-50 dark:hover:bg-slate-700 dark:bg-slate-800/60 transition-colors">
          Cancel
        </button>
        <button type="submit" [disabled]="isSubmitting"
          class="flex-1 h-11 rounded-xl bg-primary-800 hover:bg-primary-900 text-white text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
          {{ isSubmitting ? 'Saving...' : 'Record Repayment' }}
        </button>
      </div>
    </form>
  </div>
</div>
}
